"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
const d3 = __importStar(require("d3"));
const lodash_1 = __importDefault(require("lodash"));
const resize_observer_polyfill_1 = __importDefault(require("resize-observer-polyfill"));
require("./IncomeDistribution.scss");
const constants_1 = require("../../constants");
const Tooltip_1 = __importDefault(require("../Tooltip"));
const chart_helpers_1 = require("../../util/chart.helpers");
const common_module_scss_1 = __importDefault(require("../../styles/common.module.scss"));
const colours_module_scss_1 = __importDefault(require("../../styles/colours.module.scss"));
const error_1 = require("../error");
const SourcesAndFootnotes_1 = __importDefault(require("../SourcesAndFootnotes"));
const DEFAULT_HEIGHT = 200;
const TOP_HEIGHT = 20;
const TOP_HEIGHT_TWO_LINES = 40;
const DEFAULT_OPACITY = 0.75;
const SMALL_BAR_WIDTH_RATIO = 0.15;
const BETWEEN_WIDTH = 20;
const AXIS_LABEL_SPACING = 20;
// default tickSizeInner()
const DEFAULT_TICK_SIZE = 6;
const TOOLTIP_TRANSLATE = {
  quintiles: 170,
  brackets: 60
};
const GROUP_STARTS = [{
  bracket: 0,
  small: false
}, {
  bracket: 1,
  small: false
}, {
  bracket: 21,
  small: true
}, {
  bracket: 101,
  small: true
}];
const ALL_KEYWORD = '9999';
const BRACKET_DEFS = {
  1: 0,
  2: 10000,
  3: 20000,
  4: 30000,
  5: 40000,
  6: 50000,
  7: 60000,
  8: 70000,
  9: 80000,
  10: 90000,
  11: 100000,
  12: 110000,
  13: 120000,
  14: 130000,
  15: 140000,
  16: 150000,
  17: 160000,
  18: 170000,
  19: 180000,
  20: 190000,
  21: 200000,
  31: 300000,
  41: 400000,
  51: 500000,
  61: 600000,
  71: 700000,
  81: 800000,
  91: 900000,
  101: 1000000
};
const EXTRA_LABELS = {
  0: '≤$0',
  21: '$200K',
  101: '$1M+'
};
const X_LABEL = 'Earned income';
const Y_LABEL = 'of families';
const TOP_SPACE = 20;
const QUINTILE_NAMES = {
  1: 'Bottom',
  2: 'Second',
  3: 'Middle',
  4: 'Fourth',
  5: 'Top',
  9999: 'Top'
};
function createScales(_ref) {
  let {
    data,
    params
  } = _ref;
  const {
    yDomain,
    margins,
    betweenWidth,
    smallBarWidthRatio,
    allKeyword
  } = params;
  const {
    height,
    width
  } = this.chartArea(margins);
  const bracketGroups = GROUP_STARTS.map((_ref2, i) => {
    let {
      bracket,
      small
    } = _ref2;
    const nextStart = GROUP_STARTS[i + 1] ? GROUP_STARTS[i + 1].bracket : Infinity;
    const brackets = (0, lodash_1.default)(data.metric.brackets).pickBy((v, k) => k >= bracket && k < nextStart).values();
    return {
      start: bracket,
      brackets,
      small
    };
  });
  const barPortion = (0, lodash_1.default)(bracketGroups).map(_ref3 => {
    let {
      brackets,
      small
    } = _ref3;
    return brackets.size() * (small ? smallBarWidthRatio : 1);
  }).sum();
  const barWidth = (width - (betweenWidth * bracketGroups.length - 1)) / barPortion;
  const xScales = {};
  let left = 0;
  let end = 0;
  bracketGroups.forEach(_ref4 => {
    let {
      start,
      brackets,
      small
    } = _ref4;
    const dataXDomain = brackets.map(allKeyword).map('darkhorse_income').sortBy(v => Number(v)).value();
    const scaleWidth = barWidth * dataXDomain.length * (small ? smallBarWidthRatio : 1);
    xScales[start] = d3.scaleBand().domain(dataXDomain).range([left, left + scaleWidth]);
    end = left;
    left += scaleWidth + betweenWidth;
  });
  xScales.range = () => [0, end];
  const totalFamiliesBuckets = IncomeDistribution.totalFamiliesBuckets({
    data,
    params
  });
  const maxBucket = lodash_1.default.last(totalFamiliesBuckets).value;
  const dataYDomain = [0, maxBucket];
  return {
    xScales,
    yScale: d3.scaleLinear().domain(yDomain || dataYDomain).range([height, 0])
  };
}
class IncomeDistribution {
  constructor(container, width, height) {
    this.chartType = constants_1.CHART_TYPES.IncomeDistribution;
    this.cssPrefix = 'income-distribution';
    this.width = width || 1000;
    this.height = height || DEFAULT_HEIGHT;
    this.margins = {
      top: 35,
      bottom: 20,
      left: 70,
      right: 20
    };
    this.title = container.append('div').classed('chart-title', true);
    this.subtitle = container.append('div').classed('chart-subtitle', true);
    this.container = container.classed('income-distribution', true).classed('dh-chart-wrapper', true);
    this.topSvg = container.append('svg').classed('income-hover', true);
    this.svg = container.append('svg').classed('income-distribution', true);
    this.sourceContainer = container.append('div');
    this.tooltip = new Tooltip_1.default(container);
    this.sources = new SourcesAndFootnotes_1.default(this.sourceContainer);
    this.idNumber = 0;
    this.setIDNumber();
    this.initGroups();
    this.ro = new resize_observer_polyfill_1.default(entries => {
      entries.forEach(entry => {
        const {
          width: containerWidth
        } = entry.contentRect;
        requestAnimationFrame(() => {
          this.width = containerWidth;
          this.redrawContent();
        });
      });
    });
    this.ro.observe(container.node());
  }
  setIDNumber() {
    let idCount = 0;
    let maskID = `income-mask-all-${idCount}`;
    let maskExistsSelection = d3.select(`#${maskID}`);
    while (!maskExistsSelection.empty() && idCount < 50) {
      idCount += 1;
      maskID = `${maskID.split('-').slice(0, -1).join('-')}-${idCount}`;
      maskExistsSelection = d3.select(`#${maskID}`);
    }
    this.idNumber = idCount;
  }
  initGroups() {
    this.topSvg.append('g').classed('income-top-all', true);
    this.svg.append('defs').append('mask').attr('id', `income-mask-all-${this.idNumber}`).append('rect');
    const incomeAll = this.svg.append('g').classed('income-chart-all', true);
    incomeAll.append('g').classed('axis', true).classed('x', true);
    incomeAll.append('g').classed('axis', true).classed('y', true);
    incomeAll.append('g').classed('axis', true).classed('x-label', true);
    incomeAll.append('g').classed('axis', true).classed('y-label', true);
    incomeAll.append('g').classed('axis', true).classed('top-axis', true);
    incomeAll.append('g').classed('income-bars', true);
    this.svg.append('g').classed('income-cutoffs', true);
    error_1.initError.call(this);
  }
  async data(promises, options) {
    const fetched = await error_1.tryChartPromises.call(this, promises);
    if (!fetched) return null;
    return {
      data: fetched.data,
      options
    };
  }
  getDrawParams(_ref5) {
    let {
      data,
      options: {
        margins = {},
        primaryColor = colours_module_scss_1.default.chartcolourdefault0,
        axisTextColor = common_module_scss_1.default.chartAxisFontColor,
        quintileColor = common_module_scss_1.default.chartAxisFontColor,
        cutoffFontSize = 14,
        lineBreak = true,
        smallBarWidthRatio = SMALL_BAR_WIDTH_RATIO,
        betweenWidth = BETWEEN_WIDTH,
        allKeyword = ALL_KEYWORD,
        showSourcesAndFootnotes = true,
        ...otherOptions
      }
    } = _ref5;
    const params = {
      ...(0, chart_helpers_1.getDefaultDrawParams)({
        data,
        parent: null,
        options: otherOptions
      }, this.margins),
      primaryColor,
      axisTextColor,
      quintileColor,
      cutoffFontSize,
      lineBreak,
      smallBarWidthRatio,
      betweenWidth,
      allKeyword,
      showSourcesAndFootnotes
    };
    const {
      top,
      right,
      bottom,
      left
    } = margins;
    params.margins = {
      top: this.margins.top + (top || 0),
      right: this.margins.right + (right || 0),
      bottom: this.margins.bottom + (bottom || 0) + AXIS_LABEL_SPACING,
      left: this.margins.left + (left || 0)
    };
    return params;
  }
  chartArea(margins) {
    return {
      width: this.width - margins.left - margins.right,
      height: this.height - margins.top - margins.bottom
    };
  }
  async draw(promises) {
    let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    const allData = await this.data(promises, options);
    if (!allData) return false;
    const {
      data: datas
    } = allData;
    const optionParams = this.getDrawParams({
      data: datas,
      options
    });
    const drawParams = {
      data: datas[0],
      params: optionParams
    };
    this.drawContent(drawParams);
    return true;
  }
  redrawContent() {
    if (this.cachedParams) {
      this.drawContent(this.cachedParams);
    }
  }
  drawContent(drawParams) {
    this.cachedParams = drawParams;
    const {
      data,
      params
    } = drawParams;
    const lineY = params.lineBreak ? TOP_HEIGHT_TWO_LINES : TOP_HEIGHT;
    this.topSvg.attr('viewBox', `0 ${TOP_SPACE / 2} ${this.width} ${lineY + TOP_SPACE}`);
    this.topSvg.attr('height', lineY + TOP_SPACE * 2);
    chart_helpers_1.drawTitle.call(this, this.title, this.subtitle, {
      params
    });
    if (params.showSourcesAndFootnotes) {
      this.sources.draw([data], params);
    }
    const {
      height: titleHeight
    } = this.title.node().getBoundingClientRect();
    const {
      height: subtitleHeight
    } = this.subtitle.node().getBoundingClientRect();
    const {
      width,
      height: wrapperHeight
    } = this.container.node().getBoundingClientRect();
    const {
      height: topHeight
    } = this.topSvg.node().getBoundingClientRect();
    const {
      height: footerHeight
    } = this.sourceContainer.node().getBoundingClientRect();
    const absHeight = Math.max(DEFAULT_HEIGHT, wrapperHeight - titleHeight - subtitleHeight - topHeight - footerHeight);
    this.height = absHeight * this.width / width;
    this.svg.attr('viewBox', `0 0 ${this.width} ${this.height}`);
    const {
      xScales,
      yScale
    } = createScales.call(this, {
      data,
      params
    });
    this.xScales = xScales;
    this.yScale = yScale;
    this.drawIncomeMasks(drawParams);
    this.drawQuintileMasks(drawParams);
    this.drawTop(drawParams);
    this.drawBars(drawParams);
    this.drawAxes(drawParams);
    this.drawQuintileLines(drawParams);
    this.topSvg.select('g.income-top-all').attr('transform', `translate(${params.margins.left}, ${TOP_SPACE})`);
    this.svg.select('g.income-chart-all').attr('transform', `translate(${params.margins.left}, ${params.margins.top})`);
    const chartBox = this.svg.node().getBoundingClientRect();
    this.title.style('margin-left', params.margins.left * chartBox.width / this.width);
    this.subtitle.style('margin-left', params.margins.left * chartBox.width / this.width);
  }
  static quintiles(data) {
    return Object.values(data.metric.quintiles);
  }
  static getIncomeBracket(income) {
    return (0, lodash_1.default)(BRACKET_DEFS).entries().sortBy(_ref6 => {
      let [k] = _ref6;
      return Number(k);
    }).findLast(_ref7 => {
      let [, v] = _ref7;
      return v <= income;
    })[0];
  }
  getXScale(bracket) {
    return (0, lodash_1.default)(this.xScales).entries().sortBy(_ref8 => {
      let [k] = _ref8;
      return Number(k);
    }).findLast(_ref9 => {
      let [k] = _ref9;
      return Number(k) <= bracket;
    })[1];
  }
  xAccessor(d) {
    return this.getXScale(d.darkhorse_income)(d.darkhorse_income);
  }
  widthAccessor(d) {
    return this.getXScale(d.darkhorse_income).bandwidth();
  }
  quintileStart(d) {
    if (d.start_income === undefined) {
      return 0;
    }
    const entries = (0, lodash_1.default)(BRACKET_DEFS).entries();
    const arr = entries.value();
    const firstAbove = entries.sortBy(_ref10 => {
      let [k] = _ref10;
      return Number(k);
    }).findIndex(_ref11 => {
      let [, v] = _ref11;
      return Number(v) > Number(d.start_income);
    });
    const fraction = (Number(d.start_income) - arr[firstAbove - 1][1]) / (arr[firstAbove][1] - arr[firstAbove - 1][1]);
    const scale = this.getXScale(IncomeDistribution.getIncomeBracket(d.start_income));
    return scale(Number(arr[firstAbove - 1][0])) + scale.bandwidth() * fraction;
  }
  nextQuintileStart(d, i, data, params, ignoreEnd) {
    // going off the end, or top 20% includes top 1%
    if (i + 1 >= data.length || ignoreEnd && data.length === 6 && i === 4) {
      return this.chartArea(params.margins).width - this.quintileStart(data[i]);
    }
    return this.quintileStart(data[i + 1]) - this.quintileStart(data[i]);
  }
  static totalFamilies(_ref12) {
    let {
      data,
      params
    } = _ref12;
    return (0, lodash_1.default)(data.metric.brackets).map(d => d[params.allKeyword]).sumBy(v => Number(v.number_families));
  }
  static totalFamiliesBuckets(_ref13) {
    let {
      data,
      params
    } = _ref13;
    const totalFamilies = IncomeDistribution.totalFamilies({
      data,
      params
    });
    return lodash_1.default.map(data.metric.brackets, d => Number(d[params.allKeyword].number_families)).map(d => ({
      value: d,
      percent: d / totalFamilies
    })).sort((a, b) => a.percent < b.percent ? -1 : 1);
  }
  static percentTotals(_ref14, type) {
    let {
      data,
      params
    } = _ref14;
    if (type === 'quintiles') {
      return {
        taxes: (0, lodash_1.default)(data.metric.quintiles).values().filter(d => d.top_1_indicator !== '1').sumBy(d => Number(d.aggr_taxes_total)),
        assistance: (0, lodash_1.default)(data.metric.quintiles).values().filter(d => d.top_1_indicator !== '1').sumBy(d => Number(d.aggr_income_transfers))
      };
    }
    return {
      taxes: (0, lodash_1.default)(data.metric.brackets).values().sumBy(d => Number(d[params.allKeyword].aggr_taxes_total)),
      assistance: (0, lodash_1.default)(data.metric.brackets).values().sumBy(d => Number(d[params.allKeyword].aggr_income_transfers))
    };
  }
  static tooltipQuintileRows(drawParams, d) {
    const {
      params
    } = drawParams;
    const {
      taxes,
      assistance
    } = IncomeDistribution.percentTotals(drawParams, 'quintiles');
    const percentFormat = (0, chart_helpers_1.valueFormat)({
      params: {
        ...params,
        format: 'percent'
      }
    });
    const dollarFormat = (0, chart_helpers_1.valueFormat)({
      params: {
        ...params,
        format: 'dollars'
      }
    });
    const revenueValue = Number(d.aggr_taxes_total / taxes);
    const revenueString = `Pay <span style="color: ${params.primaryColor}">${percentFormat(revenueValue)}</span> of all US tax revenue`;
    const assistanceValue = Number(d.aggr_income_transfers / assistance);
    const assistanceString = `Receive <span style="color: ${params.primaryColor}">${percentFormat(assistanceValue)}</span> of all US gov't assistance`;
    return [{
      type: 'breakdown',
      key: 'Average income',
      value: dollarFormat(d.avg_income_market),
      breakdown: [{
        key: 'avg taxes',
        value: dollarFormat(d.avg_taxes_total),
        sign: '-'
      }, {
        key: 'avg assistance',
        value: dollarFormat(d.avg_income_transfers),
        sign: '+'
      }]
    }, {
      type: 'value',
      html: true,
      key: 'taxes',
      value: revenueString
    }, {
      type: 'bar',
      key: 'taxes-bar',
      value: revenueValue
    }, {
      type: 'value',
      html: true,
      key: 'assistance',
      value: assistanceString
    }, {
      type: 'bar',
      key: 'assistance-bar',
      value: assistanceValue
    }];
  }
  static tooltipBracketRows(drawParams, d) {
    const {
      params
    } = drawParams;
    const percentFormat = (0, chart_helpers_1.valueFormat)({
      params: {
        ...params,
        format: 'percent'
      }
    });
    const families = IncomeDistribution.totalFamilies(drawParams);
    return [{
      type: 'value',
      key: 'percent',
      value: percentFormat(d.number_families / families),
      styles: {
        'font-size': '24px'
      }
    }, {
      type: 'value',
      key: 'extraText',
      value: 'of all families',
      styles: {
        color: null,
        'font-size': '16px',
        'font-weight': 'normal',
        'white-space': 'nowrap'
      }
    }];
  }
  static quintileTitle(d) {
    const percent = d.top_1_indicator === '1' ? '1' : '20';
    return `${QUINTILE_NAMES[d.darkhorse_quintile]} ${percent}% of US earners`;
  }
  static bracketTitle(d, data, params) {
    const format = (0, chart_helpers_1.valueFormat)({
      params: {
        ...params,
        format: 'dollars'
      }
    });
    if (d.darkhorse_income === 0) {
      return '<$0';
    }
    const thisNum = format(BRACKET_DEFS[d.darkhorse_income]);
    if (data.findIndex(b => b.darkhorse_income === d.darkhorse_income) + 1 >= data.length) {
      return `${thisNum}+`;
    }
    const nextD = data[data.findIndex(b => b.darkhorse_income === d.darkhorse_income) + 1];
    return `${format(BRACKET_DEFS[d.darkhorse_income])} - ${format(BRACKET_DEFS[nextD.darkhorse_income])} income`;
  }
  showTooltip(drawParams, d, type, event) {
    const {
      data,
      params
    } = drawParams;
    const containerDim = this.container.node().getBoundingClientRect();
    const svgDim = this.svg.node().getBoundingClientRect();
    const tooltipTranslate = TOOLTIP_TRANSLATE[type] + this.xScales[0].bandwidth();
    const {
      clientX: mouseX
    } = event;
    const x = mouseX - containerDim.left + tooltipTranslate;
    const y = svgDim.top - containerDim.top + svgDim.height / 2;
    const rowFunc = type === 'quintiles' ? IncomeDistribution.tooltipQuintileRows : IncomeDistribution.tooltipBracketRows;
    const rows = rowFunc.call(this, drawParams, d);
    const brackets = Object.values(data.metric.brackets).map(b => b[params.allKeyword]);
    const title = type === 'quintiles' ? IncomeDistribution.quintileTitle(d) : IncomeDistribution.bracketTitle(d, brackets, params);
    const topContent = {
      title: {
        value: title
      }
    };
    this.tooltip.draw(x, y, topContent, rows, {
      primaryColour: params.primaryColor,
      secondaryColour: params.primaryColor
    }, null, 'center');
  }
  highlightBracket(datum) {
    const chartBarGroup = this.svg.select('g.income-bars');
    chartBarGroup.selectAll('rect.income-bar-rect').attr('mask', `url(#income-mask-bracket-${this.idNumber}-${datum.darkhorse_income})`);
  }
  highlightQuintile(datum) {
    const quintiles = this.topSvg.selectAll('g.income-quintile');
    const cutoffs = this.svg.selectAll('g.income-cutoff');
    const chartBarGroup = this.svg.select('g.income-bars');
    quintiles.filter((d, i) => {
      if (quintiles.data().length === 6 && i === 5) {
        return d.darkhorse_quintile === datum.darkhorse_quintile || datum.darkhorse_quintile === '5';
      }
      return d.darkhorse_quintile === datum.darkhorse_quintile;
    }).style('opacity', null);
    cutoffs.filter(d => Number(d.darkhorse_quintile) === Number(datum.darkhorse_quintile) || Number(d.darkhorse_quintile) === Number(datum.darkhorse_quintile) + 1 || d.top_1_indicator === '1' && datum.darkhorse_quintile === '5').style('opacity', null);
    chartBarGroup.selectAll('rect.income-bar-rect').attr('mask', `url(#income-mask-quintile-${this.idNumber}-${datum.darkhorse_quintile})`);
  }
  unhighlight() {
    const quintiles = this.topSvg.selectAll('g.income-quintile');
    const cutoffs = this.svg.selectAll('g.income-cutoff');
    const chartBarGroup = this.svg.select('g.income-bars');
    quintiles.style('opacity', DEFAULT_OPACITY);
    cutoffs.style('opacity', DEFAULT_OPACITY);
    chartBarGroup.selectAll('rect.income-bar-rect').attr('mask', `url(#income-mask-all-${this.idNumber})`);
  }
  drawIncomeMasks(_ref15) {
    let {
      data,
      params
    } = _ref15;
    const defs = this.svg.select('defs');
    const area = this.chartArea(params.margins);
    const allBrackets = lodash_1.default.map(data.metric.brackets, b => b[params.allKeyword]);
    // default mask
    defs.select(`#income-mask-all-${this.idNumber}`).select('rect').attr('width', area.width).attr('height', area.height).attr('fill', `rgba(255,255,255,${DEFAULT_OPACITY})`);
    // income masks
    const brackets = defs.selectAll('mask.income-mask-bracket').data(allBrackets, d => d.darkhorse_income).join(enter => {
      const masks = enter.append('mask').classed('income-mask-bracket', true).attr('id', d => `income-mask-bracket-${this.idNumber}-${d.darkhorse_income}`);
      masks.append('rect').classed('income-mask-left', true).attr('fill', `rgb(255,255,255,${DEFAULT_OPACITY})`);
      masks.append('rect').classed('income-mask-visible', true).attr('fill', 'white');
      masks.append('rect').classed('income-mask-right', true).attr('fill', `rgb(255,255,255,${DEFAULT_OPACITY})`);
      return masks;
    }, update => update);
    brackets.select('rect.income-mask-left').attr('x', 0).attr('y', 0).attr('width', d => this.xAccessor(d)).attr('height', area.height);
    brackets.select('rect.income-mask-visible').attr('x', d => this.xAccessor(d)).attr('y', 0).attr('width', d => this.widthAccessor(d)).attr('height', area.height);
    brackets.select('rect.income-mask-right').attr('x', d => this.xAccessor(d) + this.widthAccessor(d)).attr('y', 0).attr('width', d => area.width - this.xAccessor(d) - this.widthAccessor(d)).attr('height', area.height);
  }
  drawQuintileMasks(_ref16) {
    let {
      data,
      params
    } = _ref16;
    const defs = this.svg.select('defs');
    const area = this.chartArea(params.margins);
    // quintile masks
    const quintiles = defs.selectAll('mask.income-mask-quintile').data(IncomeDistribution.quintiles(data), d => d.darkhorse_quintile).join(enter => {
      const masks = enter.append('mask').classed('income-mask-quintile', true).attr('id', d => `income-mask-quintile-${this.idNumber}-${d.darkhorse_quintile}`);
      masks.append('rect').classed('income-mask-left', true).attr('fill', `rgb(255,255,255,${DEFAULT_OPACITY})`);
      masks.append('rect').classed('income-mask-visible', true).attr('fill', 'white');
      masks.append('rect').classed('income-mask-right', true).attr('fill', `rgb(255,255,255,${DEFAULT_OPACITY})`);
      return masks;
    }, update => update);
    quintiles.select('rect.income-mask-left').attr('x', 0).attr('y', 0).attr('width', d => this.quintileStart(d)).attr('height', area.height);
    quintiles.select('rect.income-mask-visible').attr('transform', d => `translate(${this.quintileStart(d)}, 0)`).attr('x', 0).attr('y', 0).attr('width', (d, i) => this.nextQuintileStart(d, i, quintiles.data(), params, true)).attr('height', area.height);
    quintiles.select('rect.income-mask-right').attr('transform', d => `translate(${this.quintileStart(d)}, 0)`).attr('x', (d, i) => this.nextQuintileStart(d, i, quintiles.data(), params, true)).attr('y', 0).attr('width', (d, i) => area.width - this.quintileStart(d) - this.nextQuintileStart(d, i, quintiles.data(), params, true)).attr('height', area.height);
  }
  static quintileText(d) {
    const firstHalf = QUINTILE_NAMES[d.darkhorse_quintile];
    const secondHalf = Number(d.top_1_indicator) === 1 ? '1%' : `20%${d.darkhorse_quintile === '5' ? ' of US earners' : ''}`;
    return {
      left: firstHalf,
      right: secondHalf,
      combined: `${firstHalf} ${secondHalf}`
    };
  }
  drawTop(drawParams) {
    const topGroup = this.topSvg.select('g.income-top-all');
    const {
      data,
      params
    } = drawParams;
    const chart = this;
    const quintiles = topGroup.selectAll('g.income-quintile').data(IncomeDistribution.quintiles(data), d => d.darkhorse_quintile).join(enter => {
      const groups = enter.append('g').classed('income-quintile', true);
      groups.append('text').classed('quintile-top', true);
      groups.append('text').classed('quintile-bottom', true);
      groups.append('line').classed('quintile-underline', true);
      groups.append('rect').classed('quintile-hover', true);
      return groups;
    }, update => update).attr('transform', d => `translate(${this.quintileStart(d)}, 0)`).style('opacity', DEFAULT_OPACITY);
    quintiles.select('.quintile-top').attr('y', 0).attr('dy', '1em').style('fill', params.quintileColor).text(d => params.lineBreak ? IncomeDistribution.quintileText(d).left : IncomeDistribution.quintileText(d).combined);
    quintiles.select('.quintile-bottom').attr('y', TOP_HEIGHT_TWO_LINES * 0.5).attr('dy', '1em').style('fill', params.axisTextColor).text(d => params.lineBreak ? IncomeDistribution.quintileText(d).right : '');
    const lineY = params.lineBreak ? TOP_HEIGHT_TWO_LINES : TOP_HEIGHT;
    quintiles.select('.quintile-underline').attr('x1', 0).attr('y1', lineY - 2).attr('x2', (d, i) => this.nextQuintileStart(d, i, quintiles.data(), params) - 10).attr('y2', lineY - 2).style('stroke', params.quintileColor);
    quintiles.select('.quintile-hover').attr('x', 0).attr('y', 0).attr('width', (d, i) => this.nextQuintileStart(d, i, quintiles.data(), params) - 10).attr('height', lineY).on('mousemove', lodash_1.default.throttle((event, d) => {
      const i = quintiles.select('.quintile-hover').nodes().indexOf(event.currentTarget);
      chart.highlightQuintile(d, i);
      chart.showTooltip(drawParams, d, 'quintiles', event);
    }, constants_1.THROTTLE, {
      trailing: false
    }), {
      passive: true
    }).on('mouseout', () => {
      this.unhighlight();
      this.tooltip.hide();
    }, {
      passive: true
    });
  }
  drawQuintileLines(_ref17) {
    let {
      data,
      params
    } = _ref17;
    const cutoffGroup = this.svg.select('g.income-cutoffs').attr('transform', `translate(${params.margins.left}, 0)`);
    const cutoffs = cutoffGroup.selectAll('g.income-cutoff').data(IncomeDistribution.quintiles(data).filter(d => Object.prototype.hasOwnProperty.call(d, 'start_income')), d => d.darkhorse_quintile).join(enter => {
      const groups = enter.append('g').classed('income-cutoff', true);
      groups.append('text').classed('cutoff-value', true);
      groups.append('line').classed('cutoff-line', true);
      return groups;
    }, update => update).attr('transform', d => `translate(${this.quintileStart(d)}, 0)`).style('opacity', DEFAULT_OPACITY);
    cutoffs.select('.cutoff-value').attr('x', 0).attr('y', params.margins.top - 5).style('fill', params.quintileColor).style('font-size', `${params.cutoffFontSize}px`).text(d => {
      const value = Math.round(d.start_income / 1000) * 1000;
      return (0, chart_helpers_1.valueFormat)({
        params: {
          ...params,
          format: 'dollars'
        }
      })(value);
    });
    cutoffs.select('.cutoff-line').attr('x1', 0).attr('y1', params.margins.top).attr('x2', 0).attr('y2', params.margins.top + this.yScale.range()[0]).style('stroke', params.quintileColor);
  }
  drawBars(drawParams) {
    const {
      data,
      params
    } = drawParams;
    const {
      height
    } = this.chartArea(params.margins);
    const chart = this;
    const chartBarGroup = this.svg.select('g.income-bars');
    const allBrackets = lodash_1.default.map(data.metric.brackets, b => b[params.allKeyword]);
    const barGroups = chartBarGroup.selectAll('g.income-bar').data(allBrackets, d => d.darkhorse_income).join(enter => {
      const bars = enter.append('g').classed('income-bar', true);
      bars.append('rect').classed('income-bar-rect', true);
      bars.append('rect').classed('income-bar-top', true);
      bars.append('rect').classed('income-bar-hover', true);
      return bars;
    }, update => update);
    barGroups.selectAll('rect.income-bar-rect').attr('x', d => this.xAccessor(d)).attr('y', d => this.yScale(d.number_families)).attr('width', d => this.widthAccessor(d)).attr('height', d => height - this.yScale(d.number_families)).attr('fill', params.primaryColor).attr('mask', `url(#income-mask-all-${this.idNumber})`);
    barGroups.selectAll('rect.income-bar-top').attr('x', d => this.xAccessor(d)).attr('y', d => this.yScale(d.number_families)).attr('width', d => this.widthAccessor(d)).attr('height', d => Math.min(height - this.yScale(d.number_families), 5)).attr('fill', params.primaryColor);
    barGroups.selectAll('rect.income-bar-hover').attr('x', d => this.xAccessor(d)).attr('y', 0).attr('width', d => this.widthAccessor(d)).attr('height', height).on('mousemove', lodash_1.default.throttle((event, d) => {
      chart.highlightBracket(d);
      chart.showTooltip(drawParams, d, 'brackets', event);
    }, constants_1.THROTTLE, {
      trailing: false
    }), {
      passive: true
    }).on('mouseleave', () => {
      this.unhighlight();
      this.tooltip.hide();
    }, {
      passive: true
    });
  }
  drawAxes(_ref18) {
    let {
      data,
      params
    } = _ref18;
    const [, xEnd] = this.xScales.range();
    const [yStart, yEnd] = this.yScale.range();
    // const yAxisPadding = -15;
    const xAxisSpec = d3.axisBottom(this.xScales[1]).tickValues(this.xScales[1].domain().filter((d, i) => i % 2 === 0)).tickFormat(v => {
      const bracketValue = BRACKET_DEFS[v];
      if (bracketValue === undefined) {
        return '';
      }
      return (0, chart_helpers_1.valueFormat)({
        params: {
          ...params,
          format: 'dollars'
        }
      })(bracketValue);
    });
    this.svg.select('.axis.x').attr('transform', `translate(${-this.xScales[1].bandwidth() / 2}, ${yStart - yEnd})`).call(xAxisSpec).selectAll('.tick text').style('font-size', `${params.fontSize}px`).style('fill', params.axisTextColor);
    this.svg.select('.x-label').selectAll('text').data([X_LABEL]).enter().append('text');
    const xAxisText = this.svg.selectAll('.axis.x text, .axis.top-axis text');
    // line up x label with rightmost x axis tick label
    const xLabelOffset = lodash_1.default.maxBy(xAxisText.nodes(), t => t.getBoundingClientRect().x).getBoundingClientRect().width;
    this.svg.selectAll('.x-label text').attr('transform', `translate(0, ${yStart - yEnd})`).attr('x', xEnd + xLabelOffset)
    // translate + tickPadding()
    .attr('y', DEFAULT_TICK_SIZE + 23)
    // default dy for left axis
    .attr('dy', '0.32em').style('font-size', `${params.fontSize}px`).style('fill', params.axisTextColor).text(d => d);
    const totalFamilies = IncomeDistribution.totalFamilies({
      data,
      params
    });
    const totalFamiliesBuckets = IncomeDistribution.totalFamiliesBuckets({
      data,
      params
    });
    const yTickCount = 3;
    const yTickMax = lodash_1.default.last(totalFamiliesBuckets).percent;
    const yTickValues = lodash_1.default.range(0, yTickCount, 1).map(i => yTickMax / (yTickCount - 1) * i);
    const yTicks = yTickValues.map(v => v * totalFamilies);
    const yAxisSpec = d3.axisLeft(this.yScale).tickValues(yTicks).tickFormat(v => {
      const percent = Number(v) / IncomeDistribution.totalFamilies({
        data,
        params
      });
      return (0, chart_helpers_1.valueFormat)({
        params: {
          ...params,
          format: 'percent'
        }
      })(percent, {
        ticks: yTicks
      });
    });
    const yAxis = this.svg.select('.axis.y').call(yAxisSpec);
    yAxis.selectAll('.tick text').style('font-size', `${params.fontSize}px`).style('fill', params.axisTextColor);
    this.svg.select('.y-label').selectAll('text').data([Y_LABEL]).enter().append('text');
    this.svg.selectAll('.y-label text')
    // default x
    .attr('x', -yAxisSpec.tickSizeInner() - yAxisSpec.tickPadding()).attr('y', 22)
    // default dy for left axis
    .attr('dy', '0.32em').style('font-size', `${params.fontSize}px`).style('fill', params.axisTextColor).text(d => d);
    this.svg.select('.top-axis').attr('transform', `translate(0, ${yStart - yEnd})`).selectAll('text').data(Object.entries(EXTRA_LABELS), d => d[0]).enter().append('text');
    this.svg.selectAll('.top-axis text').attr('x', d => this.getXScale(d[0])(d[0]))
    // default y
    .attr('y', xAxisSpec.tickSizeInner() + xAxisSpec.tickPadding())
    // default dy for bottom axis
    .attr('dy', '0.71em').style('font-size', `${params.fontSize}px`).style('fill', params.axisTextColor).text(d => d[1]);
  }
}
exports.default = IncomeDistribution;